import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import { SliceStage, SliceStageParameters } from '../stages/filters/SliceStage';

export type SliceParams = BlockParameters & SliceStageParameters;

@AddMetadata({ type: BlockKeys.Slice, name: 'Slice XYZ', description: 'Slices the volume in the three cardinal directions' })
class SliceBlock extends PipelineBlock<SliceParams> {
    constructor(params: SliceParams, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        return [new SliceStage(this.getParams())];
    }
}

export default SliceBlock;
